const skill = [
  {
    title: "FLUTTER DEVELOPMENT",
    data: [
      {
        imgUrl: "https://img.icons8.com/color/32/000000/flutter.png",
        title: "FLUTTER",
        percentage: 95,
        className: "skills__flutter",
      },
      {
        imgUrl: "https://img.icons8.com/color/32/000000/dart.png",
        title: "DART",
        percentage: 95,
        className: "skills__dart",
      },
    ],
  },
  {
    title: "iOS DEVELOPMENT",
    data: [
      {
        imgUrl: "https://img.icons8.com/color/32/000000/swiftui.png",
        title: "SWIFT UI",
        percentage: 85,
        className: "skills__swift",
      },
      {
        imgUrl:
          "https://developer.apple.com/assets/elements/icons/create-ml/create-ml-32x32.png",
        title: "CREATE ML",
        percentage: 80,
        className: "skills__createml",
      },
    ],
  },
  {
    title: "BLOCKCHAIN DEVELOPMENT",
    data: [
      {
        imgUrl: "assets/motoko.webp",
        title: "WEB3 USING MOTOKO",
        percentage: 70,
        className: "skills__motoko",
      },
      {
        imgUrl: "assets/hf.webp",
        title: "HYPERLEDGER FABRIC",
        percentage: 75,
        className: "skills__hf",
      },
    ],
  },
  {
    title: "FRONT-END DEVELOPMENT",
    data: [
      {
        imgUrl: "https://img.icons8.com/color/32/000000/html-5--v1.png",
        title: "HTML5",
        percentage: 95,
        className: "skills__html",
      },
      {
        imgUrl: "https://img.icons8.com/color/32/000000/css3.png",
        title: "CSS3",
        percentage: 95,
        className: "skills__css",
      },
      {
        imgUrl: "https://img.icons8.com/color/32/4a90e2/javascript.png",
        title: "JAVASCRIPT",
        percentage: 70,
        className: "skills__js",
      },
      {
        imgUrl: "https://img.icons8.com/office/32/000000/react.png",
        title: "REACT JS",
        percentage: 85,
        className: "skills__react",
      },
      {
        imgUrl: "https://img.icons8.com/dusk/32/4a90e2/paint-brush.png",
        title: "UX/UI",
        percentage: 75,
        className: "skills__ux",
      },
      {
        imgUrl: "https://img.icons8.com/color/32/000000/library.png",
        title: "BOOTSRAP, BLUMA, MATERIALIZE, TAILWIND CSS",
        percentage: 90,
        className: "skills__fw",
      },
      {
        imgUrl: "https://img.icons8.com/ios-filled/32/4a90e2/jquery.png",
        title: "JQUERY",
        percentage: 65,
        className: "skills__jq",
      },
      // {
      //   imgUrl:
      //     "https://img.icons8.com/color/32/4a90e2/java-coffee-cup-logo.png",
      //   title: "JAVA",
      //   percentage: 80,
      //   className: "skills__java",
      // },
      // {
      //   imgUrl: "https://img.icons8.com/color/32/000000/c-plus-plus-logo.png",
      //   title: "C++",
      //   percentage: 65,
      //   className: "skills__cpp",
      // },
      // {
      //   imgUrl: "https://img.icons8.com/color/32/000000/c-programming.png",
      //   title: "C",
      //   percentage: 70,
      //   className: "skills__c",
      // },
    ],
  },
  {
    title: "BACK-END DEVELOPMENT",
    data: [
      {
        imgUrl: "https://img.icons8.com/color/32/4a90e2/nodejs.png",
        title: "NODE JS",
        percentage: 80,
        className: "skills__nj",
      },
      {
        imgUrl: "https://img.icons8.com/color/32/000000/mongodb.png",
        title: "MONGODB",
        percentage: 85,
        className: "skills__mdb",
      },
      {
        imgUrl: "assets/mongoose.webp",
        title: "MONGOOSE",
        percentage: 85,
        className: "skills__mogo",
        imageCName: "mongoose",
      },
      {
        imgUrl: "https://img.icons8.com/color/32/000000/firebase.png",
        title: "FIREBASE",
        percentage: 80,
        className: "skills__firebase",
      },
    ],
  },
];

const apple = "fa fa-apple";
const playstore = "fa fa-play";
const github = "fa fa-github";
const link = "fa fa-link";

const projectApp = [
  {
    title: "Flutter",
    data: [
      {
        url: "https://chitraarasu-assets.netlify.app/jabber.mp4",
        links: [
          {
            url: "https://play.google.com/store/apps/details?id=com.csp.jabber",
            icon: playstore,
          },
          {
            url: "https://github.com/chitraarasu/Jabber",
            icon: github,
          },
        ],
      },
      {
        url: "https://chitraarasu-assets.netlify.app/preksha.mp4",
        links: [
          {
            url: "https://play.google.com/store/apps/details?id=com.prekshameditation",
            icon: playstore,
          },
          {
            url: "https://apps.apple.com/id/app/preksha-meditation/id555400552",
            icon: apple,
          },
        ],
      },
      {
        url: "https://chitraarasu-assets.netlify.app/sambodhi.mp4",
        links: [
          {
            url: "https://play.google.com/store/apps/details?id=com.sambodhi",
            icon: playstore,
          },
          {
            url: "https://apps.apple.com/us/app/sambodhi-e-library/id1486821625",
            icon: apple,
          },
        ],
      },
      {
        url: "https://chitraarasu-assets.netlify.app/skillchain-mobile.mp4",
        links: [
          {
            url: "https://github.com/chitraarasu/Skill-Chain",
            icon: github,
          },
        ],
      },
      {
        url: "https://chitraarasu-assets.netlify.app/thiral.mp4",
        links: [
          {
            url: "https://play.google.com/store/apps/details?id=com.thiral.android",
            icon: playstore,
          },
        ],
      },
      {
        url: "https://chitraarasu-assets.netlify.app/eb.mp4",
        links: [
          {
            url: "https://github.com/chitraarasu/EB-Calculator",
            icon: github,
          },
        ],
      },
      {
        url: "https://chitraarasu-assets.netlify.app/bmi.mp4",
        links: [
          {
            url: "https://github.com/chitraarasu/BMI-Calculator",
            icon: github,
          },
        ],
      },
      {
        url: "https://chitraarasu-assets.netlify.app/expense.mp4",
        links: [
          {
            url: "https://github.com/chitraarasu/Flutter-ExpenseApp",
            icon: github,
          },
        ],
      },
      {
        url: "https://chitraarasu-assets.netlify.app/shop.mp4",
        links: [
          {
            url: "https://github.com/chitraarasu/Flutter-Shop",
            icon: github,
          },
        ],
      },
      {
        url: "https://chitraarasu-assets.netlify.app/todo.mp4",
        links: [
          {
            url: "https://github.com/chitraarasu/todo_app",
            icon: github,
          },
        ],
      },
      {
        url: "https://chitraarasu-assets.netlify.app/clima.mp4",
        links: [
          {
            url: "https://github.com/chitraarasu/Clima",
            icon: github,
          },
        ],
      },
      {
        url: "https://chitraarasu-assets.netlify.app/place.mp4",
        links: [
          {
            url: "https://github.com/chitraarasu/Flutter-Favourite-Place",
            icon: github,
          },
        ],
      },
      {
        url: "https://chitraarasu-assets.netlify.app/quiz.mp4",
        links: [
          {
            url: "https://github.com/chitraarasu/Quizzler",
            icon: github,
          },
        ],
      },
      {
        url: "https://chitraarasu-assets.netlify.app/dice.mp4",
        links: [
          {
            url: "https://github.com/chitraarasu/Dice-Game-Flutter",
            icon: github,
          },
        ],
      },
    ],
  },
  {
    title: " Swift ",
    data: [
      {
        url: "https://chitraarasu-assets.netlify.app/ios/africa.mp4",
        links: [
          {
            url: "https://github.com/chitraarasu/Africa-SwiftUI",
            icon: github,
          },
        ],
      },
      {
        url: "https://chitraarasu-assets.netlify.app/ios/pinch_and_zoom.mp4",
        links: [
          {
            url: "https://github.com/chitraarasu/Pinch-SwiftUI",
            icon: github,
          },
        ],
      },
      {
        url: "https://chitraarasu-assets.netlify.app/ios/watch_notes.mp4",
        links: [
          {
            url: "https://github.com/chitraarasu/Notes-SwiftUI",
            icon: github,
          },
        ],
      },
      {
        url: "https://chitraarasu-assets.netlify.app/ios/avocados.mp4",
        links: [
          {
            url: "https://github.com/chitraarasu/Avocados-SwiftUI",
            icon: github,
          },
        ],
      },
      {
        url: "https://chitraarasu-assets.netlify.app/ios/slot_machine.mp4",
        links: [
          {
            url: "https://github.com/chitraarasu/Slot-Machine-SwiftUI",
            icon: github,
          },
        ],
      },
      {
        url: "https://chitraarasu-assets.netlify.app/ios/animation.mp4",
        links: [
          {
            url: "https://github.com/chitraarasu/Restart-SwiftUI",
            icon: github,
          },
        ],
      },
      {
        url: "https://chitraarasu-assets.netlify.app/ios/devote.mp4",
        links: [
          {
            url: "https://github.com/chitraarasu/Devote-SwiftUI",
            icon: github,
          },
        ],
      },
      {
        url: "https://chitraarasu-assets.netlify.app/ios/fruits.mp4",
        links: [
          {
            url: "https://github.com/chitraarasu/Fruitus-SwiftUI",
            icon: github,
          },
        ],
      },
      {
        url: "https://chitraarasu-assets.netlify.app/ios/touch_down.mp4",
        links: [
          {
            url: "https://github.com/chitraarasu/Touchdown-SwiftUI",
            icon: github,
          },
        ],
      },
      {
        url: "https://chitraarasu-assets.netlify.app/ios/weather.mp4",
        links: [
          {
            url: "https://github.com/chitraarasu/SwiftUI_Api",
            icon: github,
          },
        ],
      },
      {
        url: "https://chitraarasu-assets.netlify.app/ios/store.mp4",
        links: [
          {
            url: "https://github.com/chitraarasu/SwiftUI_Api",
            icon: github,
          },
        ],
      },
    ],
  },
];

const projectWeb = [
  {
    title: "Blockchain",
    data: [
      {
        projectLink: "https://github.com/chitraarasu/skill-chain-hf-bc",
        projectImg: "assets/skillchain.webp",
        title: "Skill Chain",
        desc: "This is my MCA final year project, built with private blockchain Hyperledger Fabric. Here is the project link.",
      },
      {
        projectLink:
          "https://github.com/chitraarasu/NFT-Using-Own-Crypto-Token-Reactjs",
        projectImg: "assets/opend.webp",
        title: "NFT Shop",
        desc: "I learnt about buying and selling NFTS using my own crypto token from this project.",
      },
      {
        projectLink: "https://github.com/chitraarasu/Own-Crypto-Token",
        projectImg: "assets/dsurv.webp",
        title: "Token",
        desc: "I learnt about creating my own crypto token and Authenticating with the Internet Identity from this project.",
      },
      {
        projectLink: "https://github.com/chitraarasu/DKeeper-Web3-Reactjs",
        projectImg: "assets/keeper.webp",
        title: "Keeper using motoko",
        desc: "A few months ago I did this react front without data persistence. After learning about Orthogonal Persistance in Motoko. I have integrated that functionality into this project.",
      },
      {
        projectLink: "https://github.com/chitraarasu/DBank-web3",
        projectImg: "assets/dbank.webp",
        title: "DBank",
        desc: "I have learnt lot about motoko programming from this project.",
      },
    ],
  },
  {
    title: "Websites",
    data: [
      {
        projectLink: "https://secure-secrets.onrender.com/",
        projectImg: "assets/Secrets.webp",
        title: "Secrets",
        desc: "This project helps to share your secrets with others without showing your identity, and It will calm your mind. I created this project to show my backend skills",
      },
      {
        projectLink: "https://chitraarasu-profile.netlify.app/",
        projectImg: "assets/personal website.webp",
        title: "Personal website",
        desc: "It is a simple project to show my front end skills, and its created by using HTML and CSS",
      },
      {
        projectLink: "https://chitraarasu-tindog.netlify.app/",
        projectImg: "assets/tindog.webp",
        title: "Tin Dog",
        desc: "I created this website by using bootstrap to show my frontend skills.",
      },
      {
        projectLink: "https://blog-chitraarasu.onrender.com/",
        projectImg: "assets/blogwebsite.webp",
        title: "Blog Website",
        desc: "It is the blog website, used to post a blog. the front end was written in bootstrap, HTML, CSS and the backend was written in node js, express js, MongoDB, and mongoose",
      },
      {
        projectLink: "https://jsdicee.netlify.app/",
        projectImg: "assets/dicegame.webp",
        title: "Dice Game",
        desc: "It is a simple game to have fun with friends, and It is created by using javascript.",
      },
      {
        projectLink: "https://c-musicon.netlify.app/",
        projectImg: "assets/musicwebsite.webp",
        title: "Music Game",
        desc: "It is a simple game to have fun with friends, and It is created by using javascript and jquery.",
      },
      {
        projectLink: "https://todo-list-chitraarasu.onrender.com/",
        projectImg: "assets/todolist.webp",
        title: "ToDo List",
        desc: "Todo list website is used to store your daily routine. and it is created by using node js, MongoDB and mongoose.",
      },
      {
        projectLink: "https://chitraarasusignup.onrender.com/",
        projectImg: "assets/login form.webp",
        title: "MailChimp signup page",
        desc: "It is the simple signup page created by using node js, express and MailChimp API.",
      },
      {
        projectLink: "https://firstgamefm.netlify.app/",
        projectImg: "assets/simon.webp",
        title: "Testing memory power",
        desc: "It is the project of recreating the Simon game, and its used to test your memory power and it is created by using javascript, jquery, and bootstrap",
      },
    ],
  },
  {
    title: "React JS",
    data: [
      {
        projectLink: "https://8jl1z.csb.app/",
        projectImg: "assets/keeper.webp",
        title: "Keeper",
        desc: "It is the project of recreating the Google keep, and it used to take notes. and its created by using React.",
      },

      {
        projectLink: "https://react-expenseapp.netlify.app/",
        projectImg: "assets/r3.webp",
        title: "Expense Calculator",
        desc: "",
      },
      {
        projectLink: "https://xhvh7.csb.app/",
        projectImg: "assets/react todolist.webp",
        title: "ToDo List",
        desc: "Todo list website is used to store your daily routine. and it is created by using React.",
      },
      {
        projectLink: "https://chitraarasu-react-cart.netlify.app//",
        projectImg: "assets/r1.webp",
        title: "Cart",
        desc: "",
      },
      {
        projectLink: "https://react-http-76a37.web.app/new-quote",
        projectImg: "assets/r2.webp",
        title: "Great Quotes",
        desc: "",
      },
      {
        projectLink: "https://chitraarasu-foodorder.netlify.app/",
        projectImg: "assets/r4.webp",
        title: "Food Shop",
        desc: "",
      },

      {
        projectLink: "https://009re.csb.app/",
        projectImg: "assets/form.webp",
        title: "React Form",
        desc: "It is a simple form created by using React.",
      },
    ],
  },
];

export { skill, projectApp, projectWeb };
